import { Pipe, PipeTransform } from '@angular/core';





const resultLookup = {
    1: 'BLOCKED',
    2: 'ANSWERED',
    3: "MISSED",
    4: "USER_NOT_FOUND",
    5: "DECLINED",
    6: "BUSY",
    7: "CANCELLED",
    8: "SIP_FAILURE",
    9: "ISDN_FAILURE",
    10: "OTHER_FAILURE",
    11: "INCOMPLETE",
    12: "QUEUED",
    13: "ANSWERED_BY_OTHER",
    14: "DIVERTED",
    15: "CLOSED",
    16: "CALLBACK_REQUESTED"
  };


@Pipe({
  name: 'telepoCdrResult'
})
export class TelepoCdrResultPipe implements PipeTransform {
  transform(value: number): any {
    
    return resultLookup[value];
  }
}
